/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Toolbar_StrikethroughInputs */



/**
* | output |
* | --- |
* | "Strikethrough" |
*
* @param {Editor_Toolbar_StrikethroughInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_toolbar_strikethrough = /** @type {((inputs?: Editor_Toolbar_StrikethroughInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Toolbar_StrikethroughInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Durchgestrichen")
	return /** @type {LocalizedString} */ ("Strikethrough")
});